import api from './axios';
import {
    GetAvailableWorkspacesResponse,
    WorkspaceQuotaResponse,
    WorkspaceLlmUsageResponse,
    WorkspaceContextResponse
} from './types';

const workspaceApi = {
    getAvailableWorkspaces: async (): Promise<GetAvailableWorkspacesResponse> => {
        const response = await api.get('/workspace');
        return response.data;
    },

    getWorkspaceContext: async (): Promise<WorkspaceContextResponse> => {
        const response = await api.get('/workspace/context');
        return response.data;
    },

    getWorkspaceQuota: async (): Promise<WorkspaceQuotaResponse> => {
        const response = await api.get('/workspace/quota');
        return response.data;
    },

    getWorkspaceLlmUsage: async (workspaceId: string, days: number = 30): Promise<WorkspaceLlmUsageResponse> => {
        const response = await api.get(`/workspace/${workspaceId}/llm-usage`, {
            params: { days }
        });
        return response.data;
    },

    updateWorkspaceSettings: async (
        workspaceId: string,
        payload: { timezone?: string }
    ): Promise<{ status: string; data: { id: string; name?: string; timezone?: string } }> => {
        const response = await api.patch(`/workspace/${workspaceId}/settings`, payload);
        return response.data;
    }
};

export default workspaceApi;
